import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { PedidoAPI, InputUpoloadDocumento, PedidoInfoResponse } from '@/api/sit-pedidos/pedido.api';
import { InputCreatePedido, DocumentoAnexo } from '@/store/modules/renovacao-crlv';
import { Pedido, PagePedidoInput, CreateInclusaoVeiculoPayload } from '@/models/sit-pedido/pedido';
import { Pagination } from '@/models/sit-pedido/pagination';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import dayjs from 'dayjs';
import Documento from '@/models/documento';
import ShippingCompanyContactPayload from '@/models/sit-pedido/shipping_company_contact.payload';
import ShippingCompanyCreatePayload from '@/models/sit-pedido/shipping_company_create.payload';

const api = new PedidoAPI();

const createPedido = (body: InputCreatePedido): AxiosObservable<Pedido> => {
  return api.createPedido(body);
};

const getPedidoInfo = (pedidoId: number): AxiosObservable<PedidoInfoResponse> => {
  return api.getPedidoInfo(pedidoId);
};

const createPedidoCompany = (body: any): AxiosObservable<Pedido> => {
  return api.createPedidoCompany(body);
};

const uploadDocumento = (pedidoID: number, body: InputUpoloadDocumento): Promise<any> => {
  return api.uploadDocumento(pedidoID, body).toPromise();
};

const page = (input: PagePedidoInput): Observable<Pagination<Pedido>> => {
  return api.page(input).pipe(
    map((data: any) => {
      const {
        pedidoPage: { content, pageInfo },
      } = data;
      return { content, ...pageInfo };
    })
  );
};

const show = (id: number): Observable<Pedido> => {
  return api.show(id).pipe(
    map((data: any) => {
      const { pedidoShow } = data;

      if (pedidoShow.documentosAnexos && pedidoShow.documentosAnexos.length) {
        const documentosAnexos = pedidoShow.documentosAnexos.map((d: any) => {
          const dataEmissao = d.dataEmissao
            ? dayjs(d.dataEmissao, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '';
          const dataValidade = d.dataValidade
            ? dayjs(d.dataValidade, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '';
          return { ...d, dataEmissao, dataValidade };
        });

        return { ...pedidoShow, documentosAnexos };
      }
      return pedidoShow;
    })
  );
};

const download = (body: DocumentoAnexo): AxiosObservable<any> => api.download(body);

const doDownloadFile = (data: any, file: string) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', file);
  document.body.appendChild(link);
  link.click();
};

const createInclusaoVeiculo = (data: CreateInclusaoVeiculoPayload): AxiosObservable<any> => {
  return api.createInclusaoVeiculo(data);
};

const createShippingCompanyContact = (data: ShippingCompanyContactPayload): AxiosObservable<any> =>
  api.createShippingCompanyContact(data);

const createShippingCompany = (data: ShippingCompanyCreatePayload): AxiosObservable<any> =>
  api.createShippingCompany(data);

const atuationAreasList = (): AxiosObservable<any> => api.atuationAreasList();

const servicesList = (): AxiosObservable<any> => api.servicesList();

const getFabricantes = (): AxiosObservable<any> => api.getFabricantes();

const getCarroceria = (id: number): AxiosObservable<any> => api.getCarroceria(id);

// Métodos para os endpoints de cooperados
const searchCooperado = (cpf: string): AxiosObservable<any> => api.searchCooperado(cpf);

const listCooperadosTranspotadora = (transportadoraId: number): AxiosObservable<any> =>
  api.listCooperadosTranspotadora(transportadoraId);

const getPermiteAproveitar = (veiculoTransportadoraId: number): AxiosObservable<any> =>
  api.getPermiteAproveitar(veiculoTransportadoraId);

const substituirCooperado = (body: Object): AxiosObservable<any> => api.substituirCooperado(body);

const searchEnderecoCEP = (cep: string): AxiosObservable<any> => api.searchEnderecoCEP(cep);

const uploadDocumentoSubstituicaoCooperado = (
  numeroPedido: number,
  file: File,
  key?: string
): AxiosObservable<any> => api.uploadDocumentoSubstituicaoCooperado(numeroPedido, file, key);

const listAreasAtuacao = (idTransportadora: number): AxiosObservable<any> =>
  api.listAreasAtuacao(idTransportadora);

export default {
  createPedido,
  getPedidoInfo,
  createPedidoCompany,
  uploadDocumento,
  page,
  show,
  download,
  doDownloadFile,
  createInclusaoVeiculo,
  createShippingCompanyContact,
  createShippingCompany,
  atuationAreasList,
  servicesList,
  getFabricantes,
  getCarroceria,
  searchCooperado,
  listCooperadosTranspotadora,
  getPermiteAproveitar,
  substituirCooperado,
  searchEnderecoCEP,
  uploadDocumentoSubstituicaoCooperado,
  listAreasAtuacao,
};
